import script from "./auth-phone-code.vue?vue&type=script&lang=ts&setup=true"
export * from "./auth-phone-code.vue?vue&type=script&lang=ts&setup=true"

import "./auth-phone-code.vue?vue&type=style&index=0&id=c152036c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c152036c"]])

export default __exports__